/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const CATEGORY_REVENUE_PERCENTAGE_FRAGMENT = gql`
  fragment CategoryRevenuePercentage on CategoryRevenuePercentage {
    upc
    category
    currentUpcRevenue
    currentTotalCategoryRevenue
    currentPercentage
    previousUpcRevenue
    previousTotalCategoryRevenue
    previousPercentage
    percentageChange
  }
`
